import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import { CourseManagementService } from "../course-management.service";
import Swal from "sweetalert2";
// import Swal from "sweetalert2";
@Component({
  selector: 'app-edit-course',
  templateUrl: './edit-course.component.html',
  styleUrls: ['./edit-course.component.scss']
})
export class EditCourseComponent implements OnInit {

  selectedFile: File;
  uploadCourseImage: any;

  courseResponse: any;
  courseForm: FormGroup;
  courseId: any;
  formSubmitted: boolean = false;
  ImageUpload: boolean = false;
  showImageError: boolean = true;
  courseRequest = {
    title: null,
    imageUrl: null,
    sortOrder: null,
    description: null
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.courseId = this.route.snapshot.params["course_Id"];
    this.getcourseById();
  }

  getcourseById() {
    let query = "course_id=" + this.courseId;
    this.CourseManagementService.getCourseById(query).subscribe(res => {
      if (res["message"] === "Success") {
        this.courseResponse = res.data;
        this.updateForm();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });

  }
  updateForm() {
    this.courseForm.patchValue({
      title: this.courseResponse["title"],
      sortOrder: this.courseResponse["sortOrder"],
      description: this.courseResponse["description"]
    });
    this.uploadCourseImage = this.courseResponse["imageUrl"];
    this.ImageUpload = true;
    this.showImageError = false;
  }

  initialiseForms() {
    this.courseForm = this.fb.group({
      title: ["", [Validators.required]],
      sortOrder: ["", [Validators.required]],
      description: ["", [Validators.required]],
    });
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.uploadCourseImage = this.selectedFile.name;
    this.spinner.show();
    this.CourseManagementService.uploadImage(this.selectedFile).subscribe(data => {
      if (data["message"] === "Success") {
        Swal.fire("Success", "Image uploaded successfully!", "success");
        this.courseRequest.imageUrl = data.data.fileUrl;
        this.uploadCourseImage = data.data.fileUrl;
        this.showImageError = false;
        this.ImageUpload = true;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }

  addCourse() {
    this.formSubmitted = true;
    if (this.courseForm.valid) {
      this.courseRequest.title = this.courseForm.value.title;
      this.courseRequest.sortOrder = this.courseForm.value.sortOrder;
      this.courseRequest.imageUrl = this.uploadCourseImage;
      this.courseRequest.description = this.courseForm.value.description;
      this.courseRequest['courseId'] = this.courseId;

    }
    this.CourseManagementService.updateCourse(this.courseRequest).subscribe(data => {
      this.spinner.hide();
      if (data["message"] === "Success") {
        Swal.fire("Success", "Course Updated successfully!", "success");
        this.router.navigate(["/main/course-management/view-course"]);
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
  }

  cancel() {
    this.router.navigate(["/main/course-management/view-course"]);
  }
}

